
import { jwtDecode } from 'jwt-decode'
import Cookies from 'js-cookie'

export const addCommasToNumber = (number) => {
  const numberString = number?.toString()

  const characters = numberString.split('')
  const reversedCharacters = characters.reverse()

  // Insert commas every three characters
  const resultArray = []
  for (let i = 0; i < reversedCharacters.length; i++) {
    if (i !== 0 && i % 3 === 0) {
      resultArray.push(',')
    }
    resultArray.push(reversedCharacters[i])
  }

  // Reverse the array back and join the characters
  const resultString = resultArray.reverse().join('')

  // Return the formatted number
  return resultString
}

export function isValidEmail(string) {
  const urlRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
  return urlRegex.test(string)
}

export const getUserIdFromToken = () => {
  try {
    const token = localStorage.getItem('afr-portale-authorization-token')
    const decodedToken = jwtDecode(token)
    const userId = decodedToken?.data?.userId
    return userId
  } catch (error) {
    console.log(error)
    return 0
  }

}


export const getRoleUserIdFromToken = () => {
  try {
    const token = localStorage.getItem('afr-portale-authorization-token')
    if(!token) return null
    const decodedToken = jwtDecode(token)
    const roleUserId = decodedToken?.data?.roleUserId
    return roleUserId
  } catch (error) {
    console.log(error)
    return 0
  }
}


export const toBase64 = file => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = () => resolve(reader.result);
  reader.onerror = reject;
})